import { useState } from "react";
import UserList from "./UserList";
import ActivityLog from "./ActivityLog";
import { useAdmin } from "_data/hooks/admin/useAdmin";

export default function AdminView() {
  const [showActivityLog, setShowActivityLog] = useState(false);
  const { getExportExcelData } = useAdmin();

  const getExpotExcel = () => {
    // Excel cannot be downloaded directly via browser => Call api to get excel file (protected with authentication token) and invoke download locally
    getExportExcelData((success, fileBlob, fileName) => {
      if (!success || !fileBlob) {
        return alert("Failed to export Excel file. Please try again.");
      }

      const url = window.URL.createObjectURL(fileBlob);
      const link = document.createElement("a");
      link.href = url;
      link.setAttribute("download", fileName);
      document.body.appendChild(link);
      link.click();
      document.body.removeChild(link);
    });
  };

  return (
    <div className="flex flex-col items-start justify-start w-full h-full p-5 overflow-hidden">
      <div className="flex flex-row justify-between flex-shrink-0 w-full">
        <div className="tab-selector flex flex-row min-h-[35px] tall:min-h-[50px] border border-[#EAECF0] bg-[#F9FAFB] rounded-lg p-1 tall:p-2 gap-2">
          <div
            className={`flex w-[100px] justify-center items-center rounded-lg cursor-pointer ${
              !showActivityLog && "bg-[#EEF4FF]"
            }`}
            onClick={() => setShowActivityLog(false)}
          >
            <p
              className={`${
                !showActivityLog ? "text-primaryBlue" : "text-textXLightGray"
              }  font-latoBold`}
            >
              Users
            </p>
          </div>
          <div
            className={`flex w-[100px] justify-center items-center rounded-lg cursor-pointer ${
              showActivityLog && "bg-[#EEF4FF]"
            }`}
          >
            <p
              onClick={() => setShowActivityLog(true)}
              className={`${
                showActivityLog ? "text-primaryBlue" : "text-textXLightGray"
              }  font-latoBold`}
            >
              Activities
            </p>
          </div>
        </div>
        <div className="tab-selector flex flex-row min-h-[35px] tall:min-h-[50px] border border-[#EAECF0] bg-[#EEF4FF] rounded-lg p-1 tall:p-2 gap-2">
          <div
            className={`flex w-full h-full justify-center items-center rounded-lg cursor-pointer px-3`}
            title="Export All"
            onClick={getExpotExcel}
          >
            <img className="scale-125 content-downloadIconBlue" alt="" />
          </div>
        </div>
      </div>

      <div className="flex flex-col flex-1 w-full min-h-0 mt-3">
        {!showActivityLog ? <UserList /> : <ActivityLog />}
      </div>
    </div>
  );
}
